export enum ESortOrder {
  ASC = 1,
  DESC = -1,
}
